import Home from '../topics/Home'
import Department from '../topics/Department'
import District from '../topics/District'
import Obituary from '../topics/Obituary/index'
import Traffic from '../topics/Traffic'
import Weather from '../topics/Weather'
import Search from '../topics/Search'
import Article from '../topics/Article'
import Paper from '../topics/Paper'
import NearMe from '../topics/NearMe'
import LoginRegisterAccount from '../topics/LoginRegisterAccount'
import UserGeneratedContent from '../topics/UserGeneratedContent'
import Topic from '../topics/Topic'
import NotFoundError from '../topics/Error/screens/NotFoundError'
import NewsFeed from '../topics/NewsFeed'
import OnTour from '../topics/OnTour'
import CouncilElection from '../topics/CouncilElection'
import Profile from './Profile'
import Page from './Page'
import Bookmark from './Bookmark'
import Faq from './Faq'
import Video from './Video'
import DlabSettings from './DlabSettings'

const topics = {
  Home,
  Department,
  District,
  Obituary,
  Traffic,
  Weather,
  Search,
  Article,
  Video,
  Paper,
  NearMe,
  LoginRegisterAccount,
  Profile,
  UserGeneratedContent,
  Topic,
  NewsFeed,
  NotFoundError,
  OnTour,
  CouncilElection,
  Page,
  Bookmark,
  Faq,
  DlabSettings,
}

const Topics = (name) => topics[name]

export default Topics
